import version from "../../package.json";
export const versionName = "";
export const versionNumber = version?.version;
